module.exports = __webpack_public_path__ + "img/chair_thumb.29c2aecc.jpg";